import React from "react";
import { useTable } from "../../Components/useTable";

const LiveStreamReport = () => {
  const type = "LiveStreams";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "ReportID", numeric: false, label: "Report ID" },
    { id: "ReportCode", numeric: false, label: "Report RID" },
    { id: "ReportName", numeric: false, label: "Report Name" },
    { id: "pictureUrl", numeric: false, label: "Report Picture" },
    { id: "reason", numeric: false, label: "Reason" },
    { id: "LiveID", numeric: false, label: "Live ID" },
    { id: "LiveRoomID", numeric: false, label: "Live Room ID" },
    { id: "LivehostName", numeric: false, label: "Live Host Name" },
    { id: "Livetype", numeric: false, label: "Live Type" },
    { id: "AudioID", numeric: false, label: "Audio ID" },
    { id: "AudioRoomID", numeric: false, label: "Room ID" },
    { id: "AudiohostName", numeric: false, label: "Audio Host Name" },
    // { id: "createdAt", numeric: false, label: "Created at" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default LiveStreamReport;
